import { Component } from 'react';
import store, {history} from '../../../../../store';
import ConfirmPopup from '../../../../common/confirm-popup';
import IgniteDataTable from '../../../../common/datatable';
import {deleteCategory} from '../../../../../actions/news';

class CategoriesList extends Component {
  state = {
    delete: {
      show: false
    }
  };

  handleDelete = (result) => {
    const {id} = this.state.delete;
    this.setState({delete: {show: false}});
    if (result) {
      store.dispatch(deleteCategory(id));
    }
  };

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Name'
      },
      {
        prop: 'linked-articles',
        title: 'Linked articles'
      },
    ];

    const actions = [
      {
        label: 'Edit',
        color: 'grey',
        permissions: {
          action: 'update',
          subjectClass: 'NewsCategory',
        },
        disabled: row => !row.attributes.editable,
        callback: (row) => {
          history.push(`/admin/news/categories/${row.id}`);
        }
      },
      {
        label: 'Delete',
        permissions: {
          action: 'destroy',
          subjectClass: 'NewsCategory',
        },
        disabled: row => !row.attributes.deletable,
        callback: (row) => {
          this.setState({
            delete: {
              show: true,
              id: row.id
            }
          });
        }
      }
    ];

    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={this.props.categories}
          hideId={false}
        />

        {
          this.state.delete.show && (
            <ConfirmPopup
              header="DELETE NEWS CATEGORY?"
              onClose={this.handleDelete}
            >
              <p>
                Are you sure you want to delete this news category?
              </p>
            </ConfirmPopup>
          )}
      </div>
    );
  }
}

export default CategoriesList;
